import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

function BreadcrumbHeader({ prevCrumbs, title, url, grouping }){
    const model = useSelector(state => state.site.model)
    const isAdmin = useSelector(state => state.session.isAdmin)

    return <div className="row">
        <div className="col align-self-end">
            
            <ol className="breadcrumb pull-right text-white">
                <li className="breadcrumb-item text-white"><a href="/overview">Home</a></li>
                {prevCrumbs.map(crumb => <li className="breadcrumb-item text-white">
                    <Link to={crumb.url}>{crumb.title}</Link>
                </li>)}
                <li className="breadcrumb-item text-white active">
                    <Link to={url}>{title}</Link>
                    {(!model.reseller || (model.reseller && !model.isAffiliate)) && grouping && <div className="dropdown pull-right ml-sm-2">
                        <button className="btn btn-sm btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                            {grouping === "admin" && url !== "/admin" && <Link className="dropdown-item" to="/admin">Administration</Link>}
                            {grouping === "admin" && url !== "/unit-sales-entry" && (isAdmin || (model.reseller && !model.isAffiliate) || !model.reseller) && <Link className="dropdown-item" to="/unit-sales-entry">Unit Sales Entry</Link>}
                            {grouping === "admin" && url !== "/revenue-entry" && (isAdmin || (model.reseller && !model.isAffiliate) || (model?.userSite?.type !== "TOKEN" && !model?.userSite?.attr?.isFranchise)) && <Link className="dropdown-item" to="/revenue-entry">Revenue Entry</Link>}
                            {grouping === "admin" && url !== "/logs" && isAdmin && <Link to="/logs" class="dropdown-item">Frontend Logs</Link>}
                            {grouping === "admin" && url !== "/users" && isAdmin && <Link to="/users" class="dropdown-item">Users</Link>}
                        </div>
                    </div>}
                </li>
            </ol>
        </div>
    </div>
}

BreadcrumbHeader.defaultProps = {
    title: "Administration",
    url: window.location.pathname,
    grouping: false,
    prevCrumbs: []
}

export default BreadcrumbHeader